<template>
  <div id="modalidadeEmbarques">
    <loading color="#2185d0" :active.sync="isLoading" loader="bars" :is-full-page="fullPage"></loading>
    <grafico-pizza :chart-data="dados_grafico" :options="options"></grafico-pizza>
  </div>
</template>
     
<script>
import GraficoPizza from "src/components/graficos/GraficoPizza.vue";

export default {
  name: "ModalidadeEmbarques",
  props: ["estatisticaInfo"],
  components: {
    GraficoPizza
  },
  data() {
    return {
      isLoading: false,
      fullPage: false,
      dados_grafico: {},
      options: {
        plugins: {
          // Change options for ALL labels of THIS CHART
          datalabels: {
            color: "white",
            backgroundColor: "#00000085",
clamp: true,
            anchor: "top"
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        showAllTooltips: true,
        scales: {
          yAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: true,
                min: 0
              }
            }
          ]
        }
      }
    };
  },
  methods: {
    getModalidadeEmbarques(data) {
      let url = this.$urlApi + "/api/estatisticas-modalidades-embarques";
      this.isLoading = true;
      this.axios.post(url, data).then(res => {
        //console.log(res.data);
        this.dados_grafico = {
          labels: res.data.label,
          datasets: [
            {
              label: "Modais por Embarques",
              backgroundColor: [
                "#6699FF",
                "#64D7EE",
                "#1CC8EB",
                "#2D616B",
                "#169DB8",
                "#073038",
                "#52B1C3",
                "#169DB8",
                "#183338",
                "#107185",
                "#0D5B6B"
              ],
              borderColor: "#6699FF",
              data: res.data.series
            }
          ]
        };
        this.isLoading = false;
      });
    }
  },
  watch: {
    $props: {
      handler() {
        this.getModalidadeEmbarques(this.$props.estatisticaInfo);
      },
      deep: true
    }
  }
};
</script>

<style>
</style>